export const baseURL = "https://skv-testing.moiaccount.in/testapi";
